import { getSettings, getUseCase, getBotResponses } from '@/services/bot.service'

const SET_CLIENT_ID = 'SET_CLIENT_ID'
const SET_CURRENT_USE_CASE = 'SET_CURRENT_USE_CASE'
const SET_USE_CASES = 'SET_USE_CASES'
const SET_RESPONSES = 'SET_RESPONSES'

const state = () => {
  return {
    clientId: null,
    currentUseCase: null,
    useCases: [],
    responses: null,
  }
}

const mutations = {
  [SET_CLIENT_ID]: (state, clientId) => {
    state.clientId = clientId
  },
  [SET_CURRENT_USE_CASE]: (state, useCase) => {
    state.currentUseCase = useCase
  },
  [SET_USE_CASES]: (state, useCases) => {
    state.useCases = useCases
  },
  [SET_RESPONSES]: (state, responses) => {
    state.responses = responses
  },
}

const actions = {
  setClientId: ({ commit }, clientId) => {
    commit(SET_CLIENT_ID, clientId)
  },
  getClientSettings: ({ commit, state }, urlParams) => {
    return getSettings(state.clientId, urlParams).then(useCases => {
      commit(SET_USE_CASES, useCases)
      return Promise.resolve(state.useCases)
    })
  },
  setCurrentUseCase: ({ commit, state }, currentUseCase) => {
    const key = currentUseCase.key
    return getUseCase(state.clientId, key).then(useCase => {
      commit(SET_CURRENT_USE_CASE, useCase)
      return Promise.resolve(state.currentUseCase)
    })
  },
  getBotResponses: ({ commit, state, dispatch }, { currentUseCase, urlParams }) => {
    return getBotResponses(state.clientId, currentUseCase.key, urlParams).then(responses => {
      commit(SET_RESPONSES, responses)
      dispatch('refine/updateCurrentResponse', Object.keys(state.responses.response)[0], { root: true })
      return Promise.resolve(state.responses)
    })
  },
  resetResponses: ({ commit }) => {
    commit(SET_RESPONSES, null)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
